<div class="property-preview-container">

  <div class="d-flex property-preview-container__header">
    <header class="flex-grow-1">
      <span>{{'propertyPreview.elementsSettings' | translate}}</span>
    </header>
    <mat-icon (click)="closePanel()">close</mat-icon>
  </div>

  <div class="property-content">

    <mat-accordion multi="true">
      <ng-container *ngFor="let panel of selectedPropPanels">
        <!-- <mat-expansion-panel [hideToggle]='panel.mapTableData.length === 0' [expanded]="getPanelType(panel.propOrElemType) === 'Page'"> -->
        <mat-expansion-panel [hideToggle]='panel.mapTableData.size === 0' [expanded]="true">
          <!-- Panel Header -->
          <mat-expansion-panel-header [matTooltip]="'ID : ' + panel.propId" matTooltipPosition="above">
            <mat-panel-title>
              <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
                <div class="icon-div d-flex" fxLayoutAlign="center center">
                  <mat-icon *ngIf="getPanelType(panel.propOrElemType) === 'Page'">crop_portrait_fill</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.propOrElemType) === 'Text'">title</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.propOrElemType) === 'Line'">remove</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.propOrElemType) === 'Image'">image</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.propOrElemType) === 'Rectangle'">crop_7_5</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.propOrElemType) === 'MeasurementPoint'">table_chart</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.propOrElemType) === 'VisualEvents'">photo_album</mat-icon>
                  <i class="fas fa-signature" *ngIf="getPanelType(panel.propOrElemType) === 'Signature'"></i>
                  <mat-icon *ngIf="getPanelType(panel.propOrElemType) === 'Summary'">view_list</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.propOrElemType) === 'SubTotal'">view_list</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.propOrElemType) === 'Picture'">view_list</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.propOrElemType) === 'DataPlate'">view_list</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.propOrElemType) === 'Table'">grid_on</mat-icon>
                  <mat-icon *ngIf="getPanelType(panel.propOrElemType) === 'DropDownList'">list_alt</mat-icon>
                  <div class="title-div">
                    {{ panel.title }}
                  </div>
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <!-- Panel Content -->
          <div class="selected-elem-prop-panel" *ngIf="panel.mapTableData.size">
            <div *ngIf="(getPanelType(panel.propOrElemType) === 'Page')">
              <div *ngFor="let tableData of panel.mapTableData | keyvalue: asIsOrder">
                <div *ngFor="let metadata of tableData.value">
                  <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                        [type]="getType(panel, metadata.category)" [inputType]="getInputType(panel, metadata.category)" [dynamicId]="getDynamicId(panel, metadata.category)"
                                        [maxLength]="getMaxLength(panel, metadata.category)" (changeValue)="onElemPropChange($event)">
                  </app-property-editor>
                </div>
              </div>
            </div>
            <div *ngIf="(getPanelType(panel.propOrElemType) !== 'Page' && getPanelType(panel.propOrElemType) !== 'Table' && getPanelType(panel.propOrElemType) !== 'Summary'  && getPanelType(panel.propOrElemType) !== 'SubTotal' && getPanelType(panel.propOrElemType) !== 'Picture' && getPanelType(panel.propOrElemType) !== 'DataPlate')">
              <div class="tab-menu" *ngIf="getPanelType(panel.propOrElemType) !== 'Page'">
                <span (click)="selectedTextTab='Layout'" [ngClass]="{'tab-menu__active-tab': selectedTextTab==='Layout' || !selectedTextTab || !isDisplay(panel)}"><i class="material-icons">design_services</i>{{'propertyPreview.layout' | translate}}</span>
                <span *ngIf="isDisplay(panel)" (click)="selectedTextTab='DataBinding'" [ngClass]="{'tab-menu__active-tab': selectedTextTab==='DataBinding'}"><i class="material-icons">link</i>{{'propertyPreview.dataBinding' | translate}}</span>
              </div>
              <div *ngIf="selectedTextTab==='Layout' || !selectedTextTab || !isDisplay(panel)">
                <ng-container *ngFor="let tableData of panel.mapTableData | keyvalue: asIsOrder">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header [expanded]="true" *ngIf="isDisplayExpansionPanel(tableData.key, 'Layout')">
                      <!--element settings: layout options (Position,Size,TextBox,Line,Background...)-->
                      <mat-panel-title>{{ 'objects.' + tableData.key | translate }}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container *ngFor="let metadata of tableData.value">
                      <div>
                        <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                             [type]="getType(panel, metadata.category)" [inputType]="getInputType(panel, metadata.category)" [dynamicId]="getDynamicId(panel, metadata.category)"
                                             [maxLength]="getMaxLength(panel, metadata.category)" (changeValue)="onElemPropChange($event)">
                        </app-property-editor>
                      </div>
                    </ng-container>
                  </mat-expansion-panel>
                </ng-container>
              </div>
              <!--DataBinding-->
              <div *ngIf="selectedTextTab==='DataBinding' ">
                <ng-container *ngFor="let tableData of panel.mapTableData | keyvalue: asIsOrder">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header [expanded]="true" *ngIf="isDisplayExpansionPanel(tableData.key, 'DataBinding') && isDiplayPanel(tableData.value)">
                      <mat-panel-title>{{ 'objects.' + tableData.key | translate }}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container *ngFor="let metadata of tableData.value">
                      <div *ngIf="tableData.key !== undefined && isDynamicData(metadata, getPanelType(panel.propOrElemType))">
                        <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                             [type]="getType(panel, metadata.category)" [inputType]="getInputType(panel, metadata.category)" [dynamicId]="getDynamicId(panel, metadata.category)"
                                             [maxLength]="getMaxLength(panel, metadata.category)" (changeValue)="onElemPropChange($event)">
                        </app-property-editor>
                      </div>
                    </ng-container>
                  </mat-expansion-panel>
                </ng-container>
              </div>
            </div>
            <!--Table-->
            <div *ngIf="getPanelType(panel.propOrElemType) === 'Table'">
              <div class="tab-menu">
                <span (click)="selectedTableTab='General'" [ngClass]="{'tab-menu__active-tab': selectedTableTab==='General' || !selectedTableTab}">{{'propertyPreview.general' | translate}}</span>
                <span (click)="selectedTableTab='Table'" [ngClass]="{'tab-menu__active-tab': selectedTableTab==='Table'}">{{'propertyPreview.table' | translate}}</span>
                <span (click)="selectedTableTab='Columns'" [ngClass]="{'tab-menu__active-tab': selectedTableTab==='Columns'}">{{'propertyPreview.columns' | translate}}</span>
                <span (click)="selectedTableTab='Rows'" [ngClass]="{'tab-menu__active-tab': selectedTableTab==='Rows'}">{{'propertyPreview.rows' | translate}}</span>
              </div>
              <div *ngIf="(selectedTableTab==='General' || !selectedTableTab) && getPanelType(panel.title) !== 'SubTotal'">
                <div *ngFor="let tableData of panel.mapTableData | keyvalue">
                  <ng-container *ngFor="let metadata of tableData.value">
                    <div *ngIf="metadata.category === 'GENERAL'">
                      <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                           [type]="getType(panel, metadata.category)" [inputType]="getInputType(panel, metadata.category)" [dynamicId]="getDynamicId(panel, metadata.category)"
                                           [maxLength]="getMaxLength(tableData.value, metadata.category)" (changeValue)="onElemPropChange($event)">
                      </app-property-editor>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div *ngIf="selectedTableTab==='Table'">
                <div *ngFor="let tableData of panel.mapTableData | keyvalue">
                  <ng-container *ngFor="let metadata of tableData.value">
                    <div *ngIf="metadata.category === 'TABLE'">
                      <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                           [type]="getType(panel, metadata.category)" [inputType]="getInputType(panel, metadata.category)" [dynamicId]="getDynamicId(panel, metadata.category)"
                                           [maxLength]="getMaxLength(tableData.value, metadata.category)" (changeValue)="onElemPropChange($event)">
                      </app-property-editor>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div *ngIf="selectedTableTab==='Columns'">
                <div *ngFor="let tableData of panel.mapTableData | keyvalue">
                  <ng-container *ngFor="let metadata of tableData.value">
                    <div *ngIf="metadata.category === 'COLUMN'">
                      <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                           [type]="getType(panel, metadata.category)" [inputType]="getInputType(panel, metadata.category)" [dynamicId]="getDynamicId(panel, metadata.category)"
                                           [maxLength]="getMaxLength(tableData.value, metadata.category)" (changeValue)="onElemPropChange($event)">
                      </app-property-editor>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div *ngIf="selectedTableTab==='Rows'">
                <div *ngFor="let tableData of panel.mapTableData | keyvalue">
                  <ng-container *ngFor="let metadata of tableData.value">
                    <div *ngIf="metadata.category === 'ROW'">
                      <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                           [type]="getType(panel, metadata.category)" [inputType]="getInputType(panel, metadata.category)" [dynamicId]="getDynamicId(panel, metadata.category)"
                                           [maxLength]="getMaxLength(tableData.value, metadata.category)" (changeValue)="onElemPropChange($event)">
                      </app-property-editor>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <!--ViSOL Table-->
            <div *ngIf="isVisolTable(panel.propOrElemType)">
              <div class="tab-menu">
                <span *ngIf="isGeneral(panel.propOrElemType)" (click)="selectedVISOLTab='General'" [ngClass]="{'tab-menu__active-tab': activeTab(panel.title, selectedVISOLTab) === 'General'}">{{'propertyPreview.general' | translate}}</span>
                <span *ngIf="isTitle(panel.propOrElemType)" (click)="selectedVISOLTab='Title'" [ngClass]="{'tab-menu__active-tab': activeTab(panel.title, selectedVISOLTab) === 'Title'}">{{'propertyPreview.title' | translate}}</span>
                <span *ngIf="isTable(panel.propOrElemType)" (click)="selectedVISOLTab='Table'" [ngClass]="{'tab-menu__active-tab': activeTab(panel.title, selectedVISOLTab) === 'Table'}">{{'propertyPreview.table' | translate}}</span>
                <span *ngIf="isDataPlate(panel.propOrElemType)" (click)="selectedVISOLTab='ImageInfo'" [ngClass]="{'tab-menu__active-tab': activeTab(panel.title, selectedVISOLTab) === 'ImageInfo'}">{{'propertyPreview.table' | translate}}</span>
              </div>

              <!--General-->
              <div *ngIf="activeTab(panel.propOrElemType, selectedVISOLTab) === 'General'">
                <div *ngFor="let tableData of panel.mapTableData | keyvalue: asIsOrder">
                  <ng-container *ngFor="let metadata of tableData.value">
                    <div *ngIf="metadata.category === 'GENERAL' && (getPanelType(panel.propOrElemType) === 'Picture')">
                      <span *ngIf="metadata.name !== 'isEmptyFolderDisplayed'">
                        <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                             [type]="getType(tableData.value, metadata.category)" [inputType]="getInputType(tableData.value, metadata.category)" [dynamicId]="getDynamicId(tableData.value, metadata.category)"
                                             [maxLength]="getMaxLength(tableData.value, metadata.category)" (changeValue)="onElemPropChange($event)">
                        </app-property-editor>
                      </span>
                    </div>
                    <div *ngIf="metadata.category === 'GENERAL' && (getPanelType(panel.propOrElemType) === 'Summary')">
                      <span *ngIf="metadata.name !== 'hasInspectionSummaryLink'">
                        <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                             [type]="getType(tableData.value, metadata.category)" [inputType]="getInputType(tableData.value, metadata.category)" [dynamicId]="getDynamicId(tableData.value, metadata.category)"
                                             [maxLength]="getMaxLength(tableData.value, metadata.category)" (changeValue)="onElemPropChange($event)">
                        </app-property-editor>
                      </span>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!--Title-->
              <div *ngIf="activeTab(panel.propOrElemType, selectedVISOLTab) === 'Title'">
                <ng-container *ngFor="let tableData of panel.mapTableData | keyvalue: asIsOrder">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header [expanded]="true" *ngIf="isDisplayExpansionPanel(tableData.key, 'Title') && isDiplayPanel(tableData.value)" >
                      <mat-panel-title>{{ 'objects.' + tableData.key | translate }}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container *ngFor="let metadata of tableData.value">
                      <div *ngIf="metadata.category === 'TITLE'">
                        <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                             [type]="getType(panel, metadata.category)" [inputType]="getInputType(panel, metadata.category)" [dynamicId]="getDynamicId(panel, metadata.category)"
                                             [maxLength]="getMaxLength(panel, metadata.category)" (changeValue)="onElemPropChange($event)">
                        </app-property-editor>
                      </div>
                    </ng-container>
                  </mat-expansion-panel>
                </ng-container>
              </div>

              <!--Table-->
              <div *ngIf="activeTab(panel.title, selectedVISOLTab) === 'Table'">
                <ng-container *ngFor="let tableData of panel.mapTableData | keyvalue: asIsOrder">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header [expanded]="true" *ngIf="isDisplayExpansionPanel(tableData.key, 'Table') && isDiplayPanel(tableData.value)">
                      <mat-panel-title>{{ 'objects.' + tableData.key | translate }}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container *ngFor="let metadata of tableData.value">
                      <div *ngIf="metadata.category === 'TABLE'">
                        <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                             [type]="getType(panel, metadata.category)" [inputType]="getInputType(panel, metadata.category)" [dynamicId]="getDynamicId(panel, metadata.category)"
                                             [maxLength]="getMaxLength(tableData.value, metadata.category)" (changeValue)="onElemPropChange($event)">
                        </app-property-editor>
                      </div>
                    </ng-container>
                  </mat-expansion-panel>
                </ng-container>
              </div>

              <!--DataPlate ImageInfo-->
              <div *ngIf="activeTab(panel.propOrElemType, selectedVISOLTab) === 'ImageInfo'">
                <ng-container *ngFor="let tableData of panel.mapTableData | keyvalue: asIsOrder">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header [expanded]="true" *ngIf="isDisplayExpansionPanel(tableData.key, 'ImageInfo') && isDiplayPanel(tableData.value)">
                      <mat-panel-title>{{ 'objects.' + tableData.key | translate }}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container *ngFor="let metadata of tableData.value">
                      <div *ngIf="metadata.category === 'IMAGEINFO'">
                        <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                             [type]="getType(panel, metadata.category)" [inputType]="getInputType(panel, metadata.category)" [dynamicId]="getDynamicId(panel, metadata.category)"
                                             [maxLength]="getMaxLength(panel, metadata.category)" (changeValue)="onElemPropChange($event)">
                        </app-property-editor>
                      </div>
                    </ng-container>
                  </mat-expansion-panel>
                </ng-container>
              </div>

              <!--DataPlate ImageInfoTitle ImageInfoImage-->
              <div *ngIf="activeTab(panel.propOrElemType, selectedVISOLTab) === 'ImageInfo'">
                <mat-expansion-panel>
                  <mat-expansion-panel-header [expanded]="true">
                    <mat-panel-title>{{ 'DataBinding' }}</mat-panel-title>
                  </mat-expansion-panel-header>
                  <ng-container *ngFor="let tableData of panel.mapTableData | keyvalue: asIsOrder">
                    <mat-expansion-panel class="small-panel">
                      <mat-expansion-panel-header [expanded]="true" *ngIf="(isDisplayExpansionPanel(tableData.key, 'ImageInfoTitle')
                                                                            || isDisplayExpansionPanel(tableData.key, 'ImageInfoImage'))
                                                                            && isDiplayPanel(tableData.value) ">
                      <mat-panel-title>{{ 'objects.' + tableData.key | translate }}</mat-panel-title>
                      </mat-expansion-panel-header>

                      <ng-container *ngIf="(isDisplayExpansionPanel(tableData.key, 'ImageInfoTitle')
                                            || isDisplayExpansionPanel(tableData.key, 'ImageInfoImage'))
                                            && isDiplayPanel(tableData.value) ">
                        <ng-container *ngFor="let metadata of tableData.value">
                          <div *ngIf="(metadata.category === 'IMAGEINFOTITLE' || metadata.category === 'IMAGEINFOIMAGE') && metadata.group !== 'TitlePosition'">
                            <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                                 [type]="getType(panel, metadata.category)" [inputType]="getInputType(panel, metadata.category)" [dynamicId]="getDynamicId(panel, metadata.category)"
                                                 [maxLength]="getMaxLength(panel, metadata.category)" (changeValue)="onElemPropChange($event)">
                            </app-property-editor>
                          </div>
                          <div *ngIf="(metadata.category === 'IMAGEINFOTITLE' || metadata.category === 'IMAGEINFOIMAGE') && metadata.group === 'TitlePosition'">
                            <app-property-editor [propId]="panel.propId" [metadata]="metadata" [isCommon]="false"
                                                 [type]="getType(panel, metadata.category)" [inputType]="getInputType(panel, metadata.category)" [dynamicId]="getDynamicId(panel, metadata.category)"
                                                 [maxLength]="getMaxLength(panel, metadata.category)" (changeValue)="onElemPropChange($event)">
                            </app-property-editor>
                          </div>
                        </ng-container>
                      </ng-container>
                    </mat-expansion-panel>
                  </ng-container>
                </mat-expansion-panel>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </ng-container>

    </mat-accordion>
  </div>
</div>
